export const question1 = 'What is a hackathon?';
export const question2 = 'Hacking? What is that?';
export const question3 = 'Who can participate?';
export const question4 = 'When do hacker applications open?';
export const question5 = 'How much does it cost to attend Hack Western?';
export const question6 = 'What kind of workshops and activities will there be?';
export const question7 =
  "What if I've never participated in a hackathon before?";
export const question8 = 'How many people can be on a team?';
export const question9 = 'Can I start working on my hack before the event?';
export const question10 = 'Question not here?';
